import flatten from 'lodash/flatten';
import { CURRENCY_RATIO } from './currency-helper';

export default class TrackingHelper {
    static getBasketTotalValue = (productGroups) => {
        return productGroups.reduce((accumulator, productGroup) => {
            return accumulator + productGroup.sum / CURRENCY_RATIO;
        }, 0);
    };

    static getBasketProducts = (productGroups) => {
        return flatten(productGroups.map((productGroup) =>
            productGroup.products.map((product) => ({
                item_id: product.productId,
                item_name: `${product.tag} - ${productGroup.title}`,
                price: product.price / CURRENCY_RATIO,
                quantity: product.quantity
            }))));
    };
}
